export const HOVER_DOWN_STYLE = 'shadow-md shadow-[#888] duration-200 hover:translate-y-1 hover:shadow-none';

export const GAME_START_KEY: string = 'Space';
export const CAPS_LOCK_KEY: string = 'CapsLock';
export const SHIFT_KEY: string = 'Shift';
export const COUNT_DOWNGAME_START: number = 3;
export const NON_ERROR_BONUS_SCORE: number = 300;
export const COMPLETE_TYPE_SCORE: number = 17;
export const UNMATCH_TYPE_SCORE: number = 4;
export const NO_SCORE: string = '----';
export const SPACE_MARK: string = '␣';

export const PLAY_MODE_PARAM: string = 'mode';

export const enum PLAY_MODE {
  NORMAL = 'normal',
  FREE = 'free',
}

// TODO: DBより取得
export const enum SYSTEM_TYPES {
  ONLINE = 'online',
  LICENSE = 'license',
}

export const enum INPUT_KEY_RESULT {
  UNMATCH = 'unmatch',
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete',
}

export const enum DISPLAY_THEMES {
  DISNEY = 'ディズニー',
  MICRATCH = 'マイクラッチ',
  ROBLOX = 'ロブロックス',
}

export const enum THEMES {
  DISNEY = 'disney',
  MICRATCH = 'micratch',
  ROBLOX = 'roblox',
}

export const enum DISNEY_CHARACTERS {
  MICKEY = 'mickey',
  POOH = 'pooh',
  TOY_STORY = 'toy_story',
}

export const enum MICRATCH_CHARACTERS {
  KING = 'king',
  CAPTAIN = 'captain',
  KING_AND_CAPTAIN = 'king_and_captain',
}

export const enum ROBLOX_CHARACTERS {
  HAKASE_BASE_BASEPLATE = 'hakase_baseplate',
  HAKASE_SUBURBAN = 'hakase_suburban',
  HAKASE_CASTLE = 'hakase_castle',
}

export const enum RESULT_TYPE {
  CLEAR = 'clear',
  TRY_AGAIN = 'try_again',
  LITTLE_MORE = 'little_more',
}

export const enum HAND_TYPE {
  LIFT = 'left',
  RIGHT = 'right',
  BOTH = 'both',
}

export const enum FINGER_TYPE {
  LITTLE = 'little',
  RING = 'ring',
  MIDDLE = 'middle',
  INDEX = 'index',
  THUMB = 'thumb',
}

export const SE_LIST = {
  START_BUTTON: '/sounds/common/start_button.mp3',
  UNMATCH_TYPEKEY: '/sounds/common/unmatch_typekey.mp3',
  MATCH_TYPEKEY: '/sounds/common/match_typekey.mp3',
  FINISH_TYPING: '/sounds/common/finish_typing.mp3',
  CLEAR: '/sounds/common/clear.mp3',
  COUNT_DOWN: '/sounds/common/count_down.mp3',
  CLICK_BUTTON: '/sounds/common/click_button.mp3',
};

export const enum RESULT_SHOW_PROGRESS {
  TYPE_COUNT_SCORE = 0,
  MISS_TYPE_COUNT = 1,
  SCORE_METER = 2,
  NEW_RECORD = 3,
  RESULT_TYPE = 4,
  BUTTONS = 5,
}

export const ACCESSIBLE_COURSE_CODES = {
  LICENSE: {
    micratch: ['MJ2', 'MJS', 'STC'],
    roblox: ['RBJ'],
    // NOTE: ディズニーのコースは、無条件に利用不可。
    disney: [],
  },
};